import { addClass } from '../util/dom';
import { refreshWaypoints } from '../scroll/exposeSubNav';

export default class LazyLoader {
    private readonly observer: IntersectionObserver;

    constructor() {
        this.observer = this.initIntersectionObserver();
    }

    public register(items: Element[]): void {
        items.forEach(item => this.observer.observe(item));
    }

    public loadTarget(element: HTMLElement): void {
        if (elementNotLoaded(element)) {
            const { lazy = null } = element.dataset;

            if (lazy !== null) {
                element.setAttribute('src', lazy);
            }

            const container = element.closest('.c-lazy-load');
            if (container !== null) {
                addClass(container, 'c-lazy-load--loaded');
                refreshWaypoints();
            }

            this.observer.unobserve(element);
        }
    }

    private initIntersectionObserver(): IntersectionObserver {
        return new IntersectionObserver(entries =>
            entries.forEach(({ target, isIntersecting }) => {
                if (isIntersecting) {
                    this.loadTarget(<HTMLElement>target);
                }
            })
        );
    }
}

function elementNotLoaded(n: HTMLElement): boolean {
    return !n.hasAttribute('src');
}
